export default __webpack_public_path__ + "static/media/course3.8684b6f6.png";